import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Table, Typography } from 'antd';
import { useClient } from 'src/contexts/Client/Client';
import * as rolesActions from 'src/actions/rolesActions';
import { filterMembersApiResponse } from '../utils';

import { RoleType } from 'src/types';

import { GroupMemberFiltred, MembersGroupReponseApiType } from '../types';
import { RoleListType } from 'src/reducers/rolesReducer';

type MemberListProps = {
  getRoles: () => void;
  groupId: string;
  memberRoleId: Array<RoleType>;
};

const { Text } = Typography;

const MEMBERS_PER_PAGE = 10;

const MemberList: React.FC<MemberListProps> = ({
  getRoles,
  groupId,
  memberRoleId,
}) => {
  const { get } = useClient();
  const [members, setMembers] = useState<Array<GroupMemberFiltred>>([]);
  const [loading, setLoading] = useState(false);
  const [current, setCurrent] = useState<number>(1);
  const [total, setTotal] = useState<number>(1);

  useEffect(() => {
    if (!memberRoleId) return getRoles();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!memberRoleId && loading) return;

    setLoading(true);
    get(
      `/groups/${groupId}/members?roles[]=${memberRoleId}&per_page=${MEMBERS_PER_PAGE}&page=${current}`,
      (response: MembersGroupReponseApiType) => {
        response.metadata && setTotal(response.metadata.total_count);
        setMembers(filterMembersApiResponse(response));
        setLoading(false);
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memberRoleId, current]);

  const columns = [
    {
      title: 'Nom',
      dataIndex: 'memberInfo',
      render: (member: { lastname: string }) => <Text>{member.lastname}</Text>,
      width: '25%',
    },
    {
      title: 'Prénom',
      dataIndex: 'memberInfo',
      render: (member: { firstname: string }) => (
        <Text>{member.firstname}</Text>
      ),
      width: '25%',
    },
    {
      title: 'Adresse',
      dataIndex: 'memberInfo',
      render: (member: { address: string }) => <Text>{member.address}</Text>,
      width: '40%',
    },
  ];

  return (
    <Table
      key={groupId}
      columns={columns}
      loading={loading}
      dataSource={members}
      pagination={{
        current: current,
        total: total,
        pageSize: MEMBERS_PER_PAGE,
        showSizeChanger: false,
        position: ['bottomCenter'],
      }}
      onChange={(pagination: any) => setCurrent(pagination.current)}
    />
  );
};

const mapStateToProps = ({ roles }: { roles: RoleListType }) => {
  return {
    memberRoleId: roles.items.filter(
      (role: RoleType) => role.type === 'group' && role.name === 'member'
    )[0]?.id,
  };
};

export default connect(mapStateToProps, {
  ...rolesActions,
})(MemberList);
